import {
    GetTerritoryTermsInput,
    GetTerritoryTermsOutput
} from '@amzn/coral_com-amazon-musicpapercontractconfigurationservice';

import { Observable } from 'rxjs';
import { contractConfigurationClient } from 'src/api/client';
import { KeysetPaginator, getAllKeysetPages } from 'src/api/pagination/paginator';

/**
 * Get all territory terms for the given input.
 *
 * The function automates handling of pagination, so any pagination-related
 * fields in the given input will be ignored.
 * @param input The GetTerritoryTermsInput to fetch data for.
 */
export function getFullTerritoryTerms(
    input: GetTerritoryTermsInput,
    pageSize: number = 10
): Promise<GetTerritoryTermsOutput> {
    return getAllKeysetPages(new TerritoryTermsPaginator(input), pageSize);
}

export class TerritoryTermsPaginator implements KeysetPaginator<GetTerritoryTermsOutput> {
    private readonly input: GetTerritoryTermsInput;
    private output: GetTerritoryTermsOutput;

    constructor(input: GetTerritoryTermsInput) {
        this.input = input;
        this.output = GetTerritoryTermsOutput.clone({
            territoryTerms: []
        });
    }

    nextPage(lastEvaluatedId: number | undefined, maxPageSize: number): Observable<GetTerritoryTermsOutput> {
        return contractConfigurationClient.getTerritoryTerms(
            GetTerritoryTermsInput.clone({
                ...this.input,
                lastEvaluatedId: lastEvaluatedId,
                pageSize: maxPageSize,
                isPaginationRequested: true
            })
        );
    }

    accumulate(nextPage: GetTerritoryTermsOutput): boolean {
        this.output = {
            territoryTerms: [...(this.output.territoryTerms || []), ...(nextPage.territoryTerms || [])],
            lastEvaluatedId: nextPage.lastEvaluatedId
        };

        return !nextPage.lastEvaluatedId;
    }

    getSize(): number {
        return this.output.territoryTerms?.length || 0;
    }

    getValue(): GetTerritoryTermsOutput {
        return this.output;
    }
}
